import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const AccountDeletionSuccess: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 6, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        Conta excluída com sucesso
      </Typography>
      <Typography variant="body1" gutterBottom>
        A sua conta foi removida definitivamente de nossa plataforma. Seus dados
        pessoais foram eliminados conforme nossa Política de Privacidade.
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Caso ainda receba e-mails nossos nas próximas horas, ignore: o
        processamento completo pode levar alguns minutos.
      </Typography>

      <Box sx={{ mt: 3, display: "flex", gap: 1, justifyContent: "center" }}>
        <Button variant="contained" component={RouterLink} to="/">
          Ir para início
        </Button>
        <Button variant="outlined" href="mailto:contato@mercado-agil.com">
          Suporte
        </Button>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
        Se desejar voltar a usar o Mercado Ágil no futuro, será necessário criar
        uma nova conta.
      </Typography>
    </Container>
  );
};

export default AccountDeletionSuccess;
